export const GET_SITE_CONFIG = 'GET_SITE_CONFIG'
export const GET_SITE_CONFIG_SUCCESS = 'GET_SITE_CONFIG_SUCCESS'
export const TRACE_AGENT = 'TRACE_AGENT'
export const TRACE_AGENT_SUCCESS = 'TRACE_AGENT_SUCCESS'

//用户信息
export const GET_USER = 'GET_USER'
export const GET_USER_SUCCESS = 'GET_USER_SUCCESS'
export const FRESH_USER = 'FRESH_USER'
export const UPDATE_USER_INFO_SUCCESS = 'UPDATE_USER_INFO_SUCCESS'
export const UPDATE_USER_INFO = 'UPDATE_USER_INFO'
export const SET_USERID = 'SET_USERID'

//申请用户
export const APPLY_IDENTITY = 'APPLY_IDENTITY'

// 升级豪华版
export const APPLY_PRO = 'APPLY_PRO'

//支付
export const INVOKE_WECHAT_PAY = 'INVOKE_WECHAT_PAY'
export const PAY = 'PAY'
export const PAY_SUCCESS = 'PAY_SUCCESS'

//获取身份详情
export const GET_IDENTITY = 'GET_IDENTITY'

export const GET_WECHAT_SHARE = 'GET_WECHAT_SHARE'
export const GET_WECHAT_CONFIG = 'GET_WECHAT_CONFIG'
export const SET_WECHAT_SHARE = 'SET_WECHAT_SHARE'
export const SET_WECHAT_CONFIG = 'SET_WECHAT_CONFIG'

//上传图片
export const UPLOAD_PIC = 'UPLOAD_PIC'
// 设置Token
export const SET_TOKEN = 'SET_TOKEN'
export const REMOVE_TOKEN = 'REMOVE_TOKEN'

//获取余额详情
export const GET_BALANCES_DETAIL = 'GET_BALANCES_DETAIL'
export const GET_BALANCES_DETAIL_SUCCESS = 'GET_BALANCES_DETAIL_SUCCESS'

export const GET_ITEM = 'GET_ITEM'
export const GET_ITEMS = 'GET_ITEMS'

//提取余额
export const POST_WITHDRAW = 'POST_WITHDRAW'
export const POST_WITHDRAW_SUCCESS = 'POST_WITHDRAW_SUCCESS'
export const CLEAR_BALANCES = 'CLEAR_BALANCES'

// 获取身份列表
export const GET_IDENTITIES = 'GET_IDENTITIES'
export const GET_IDENTITIES_SUCCESS = 'GET_IDENTITIES_SUCCESS'

// 推广海报二维码
export const GET_QUOTA_QR = 'GET_QUOTA_QR'

//登录
export const LOGIN = 'LOGIN'
export const POST_SMS = 'POST_SMS'
export const GET_ITEMS_V2 = 'GET_ITEMS_V2'
// 绑定手机号
export const SMS_CODE = 'SMS_CODE'
export const BIND_PHONE ='BIND_PHONE'

// 端午节
export const GET_LEAF_INFO = 'GET_LEAF_INFO'
export const GO_GET_LEAF = 'GO_GET_LEAF'
export const UPDATE_AWARD = 'UPDATE_AWARD'

// 商学院
export const GET_ALBUMS_LIST = 'GET_ALBUMS_LIST'
export const GET_ALBUMS_ITEMS = 'GET_ALBUMS_ITEMS'
export const GET_LESSON_DETAIL = 'GET_LESSON_DETAIL'

export const APPLY_REDBAG = 'APPLY_REDBAG'
export const GET_REDBAG_RECORDS = 'GET_REDBAG_RECORDS'

// 判断路径是否存在
export const GET_HAVE_PATH = 'GET_HAVE_PATH'
// 授权后给的id换取token
export const GET_USEINFO_GETONE = 'GET_USEINFO_GETONE'
// 使用token获取用户信息
export const GET_USE_GETONE = 'GET_USE_GETONE'
// 授权盟主
export const PUT_ALLIANCE_AUTH = 'PUT_ALLIANCE_AUTH'
// 设置全局的联盟ID
export const SET_ALLIANCE_ID = 'SET_ALLIANCE_ID'
// 我的店铺主页数据
export const GET_SHOP_ONE = 'GET_SHOP_ONE'
// 申请加入联盟
export const POST_JOIN_ALLIANCE = 'POST_JOIN_ALLIANCE'
// 我的联盟数据
export const GET_ALLIANCE_ONE = 'GET_ALLIANCE_ONE'
// 商家信息
export const GET_CTIVITY_LIST = 'GET_CTIVITY_LIST'
// 申请列表
export const GET_APPLY_LIST = 'GET_APPLY_LIST'
// 入盟申请
export const GET_ALLIANCE_GETONE = 'GET_ALLIANCE_GETONE'
// 申请状态
export const PUT_ALLIANCE_GETONE = 'PUT_ALLIANCE_GETONE'
// 核销录入
export const GET_SHOP_GETLIST = 'GET_SHOP_GETLIST'
// 录入数据
export const GET_DERINFO_GETONE = 'GET_DERINFO_GETONE'
// 确定录入
export const PUT_DERINFO_LOGGIN = 'PUT_DERINFO_LOGGIN'
// 获取联盟信息
export const GET_ALLIANCE_ACTIVITY = 'GET_ALLIANCE_ACTIVITY'
// 判断用户是否购买过礼包
export const GET_HAVE_ORDER = 'GET_HAVE_ORDER'
// 获取联盟优惠券
export const GET_COUPON_LISTALL = 'GET_COUPON_LISTALL'
// 获取领取的优惠券
export const GET_COUPONUSER_LISTALL = 'GET_COUPONUSER_LISTALL'
// 获取二维码
export const GET_USER_COUPONQR = 'GET_USER_COUPONQR'
// 确认核销
export const PUT_SCAN_QRCONFIRM = 'PUT_SCAN_QRCONFIRM'
// 修改联盟状态
export const PUT_ALLIANCE_STATTUS = 'PUT_ALLIANCE_STATTUS'
// 有无扫码权限
export const GET_SCANQR_PERMISSION = 'GET_SCANQR_PERMISSION'
// 再次加入联盟
export const PUT_AGAIN_APPLICATION = 'PUT_AGAIN_APPLICATION'
// 商家获益详情
export const GET_EARNING_LIST = 'GET_EARNING_LIST'
// 商家贡献详情
export const GET_RANKING_LIST = 'GET_RANKING_LIST'
// 盟主分红详情
export const GET_MASTER_LIST = 'GET_MASTER_LIST'
// 店铺获益明细
export const GET_SHOPONE_LIST = 'GET_SHOPONE_LIST'
// 店铺贡献明细
export const GET_SHOPONE_CONTRIBUTOR = 'GET_SHOPONE_CONTRIBUTOR'
// 佣金结算支付情况
export const GET_SHOP_PAYLIST = 'GET_SHOP_PAYLIST'
// 佣金结算收款情况
export const GET_SHOP_INCOMELIST = 'GET_SHOP_INCOMELIST'
// 佣金结算确定收款
export const PUT_UPDATE_STATUS = 'PUT_UPDATE_STATUS'
// 查询是否是盟主
export const GET_INFO_ISSPONSOR = 'GET_INFO_ISSPONSOR'
// 首页请求
export const GET_ALLIANCEACTIVITY_INIT = 'GET_ALLIANCEACTIVITY_INIT'

export const TO_BUY_GIFT_PACKGE = "TO_BUY_GIFT_PACKGE"

//名字缩写
export const SET_COMPANY_LOWCASE = 'SET_COMPANY_LOWCASE'
// 缓存 keepalive
export const SET_KEEP_ALIVE = 'SET_KEEP_ALIVE'

// 商品详情
export const GET_GOODS_DETAIL = 'GET_GOODS_DETAIL'

// H5 获取页面装修
export const GET_H5DETAIL_PAGE = 'GET_H5DETAIL_PAGE'

// H5 提交表单
export const POST_H5FORM_CREATE = 'POST_H5FORM_CREATE'

// H5 获取scheme码
export const POST_SCHEME_CODE = 'POST_SCHEME_CODE'